import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import { Form } from "./components/form";
import UserServices from "../../services/User";

const CreateUser = () => {

  const routes = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const createUser = async (payload) => {
    setLoading(true)
    try {
      const { message } = await UserServices.createUser(payload)
      SuccessToaster(message)
      navigate(-1)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New User</h4>
              <h6>Create new user</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={createUser} loading={loading} />
      </div>
    </div>
  );
};

export default CreateUser;
